module.exports = __webpack_public_path__ + "static/media/S1_00028.3462f2ab.jpg";